export default "__VITE_ASSET__1203c633__"